import { assign } from 'lodash'
import { TaskSource } from '../constants'
import TaskStore from './stores/TaskStore'

export default function(currentAuthor, {
  tasks,
  createStatus,
  saveStatus,
  deleteStatus,
  fetchStatus
} = {}, teammateData) {
  if (!tasks) return { tasks: [] }

  return {
    currentAuthor,
    createStatus,
    createTask: (t) => TaskStore.create(t),
    deleteStatus,
    deleteTask: (t) => TaskStore.delete(t),
    fetch: () => TaskStore.fetchAll(),
    fetchStatus,
    saveStatus,
    saveTask: (t) => TaskStore.update(t),
    tasks: mapTasks(tasks, currentAuthor),
    count: tasks.length,
    incomplete: tasks.reduce(incompleteCount, 0),

    ...teammateData
  }
}

function incompleteCount(count, task) {
  if(!task.completedAt || task.source === TaskSource.GOAL) {
    return count + 1
  } else {
    return count
  }
}

function mapTasks(tasks, currentAuthor) {
  return tasks.map(t => assign(t, {
    assignee: currentAuthor,
    author: !t.author ? {} : t.author,
  }))
}



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/tasks/TaskData.js